import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PageNavOption } from '../components/Layouts/LeftSidebar/NavOptions';
import { ThunkResult } from './index';

export const emptySecondLeftSidebarOpt = {
    name: '',
    icon: '',
    activeIcon: '',
    component: null,
    showOnSecondLeftSidebar: true,
};

export interface StateShape {
    pageNavSelectedOpt: PageNavOption | null;
}

export const defaultState: StateShape = {
    pageNavSelectedOpt: null,
};

const SET_PAGE_NAV_SELECTED_OPT = 'SET_PAGE_NAV_SELECTED_OPT';

export const actionCreators = {
    setPageNavOpt: (opt: PageNavOption): ThunkResult<Promise<void>> => {
        return async (dispatch) => {
            try {
                dispatch(adminUIReducerActions.SET_PAGE_NAV_SELECTED_OPT({ opt }));
                dispatch({ type: SET_PAGE_NAV_SELECTED_OPT, opt });
            } catch (err: any) {
                console.error(err);
            }
        };
    },
};

const adminUISlice = createSlice({
    name: 'adminUI',
    initialState: defaultState,
    reducers: {
        SET_PAGE_NAV_SELECTED_OPT(draft, action: PayloadAction<{ opt: PageNavOption }>) {
            draft.pageNavSelectedOpt = action.payload.opt;
        },
    },
});

const adminUIReducerActions = adminUISlice.actions;
export const adminUIReducer = adminUISlice.reducer;
